export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/empowered.4b2c80f7.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};